import { withAnalyticsEvents, withAnalyticsContext } from '@atlaskit/analytics-next';
import AnnouncementBannerComponent from './announcement-banner';

export default withAnalyticsContext({ componentName: 'banner' })(withAnalyticsEvents()(AnnouncementBannerComponent));
